module.exports = __webpack_public_path__ + "static/media/scale_logo.e430da26.png";